<template>
    <SeatMatrix
    v-if="venue"
    :rows="venue.rows"
    :cols="venue.columns"
    :seats="seats"
    :reservedSeats="reservedSeats"
    :selectedSeats="selectedSeats"
    :seatsStatus="seatsStatus"
    :notForSaleSeats="venue.not_for_sale"
    @onSeatSelected="onSeatSelected"
    @updateSeatType="updateSeats"
    @markUnavailableSeats="markUnavailableSeats"
    @markAvailableSeats="markAvailableSeats"
    @onSelectRow="selectRowSeats"
    @onSelectColumn="selectColumnSeats"
    @onSelectAll="selectAllSeats"
    @resetSelections="_resetSelectedSeats()"
    @deleteSelected="markSeatsInaccessible()"
    @allowSelected="markSeatsAccessible()"
  ></SeatMatrix>
</template>
<script>
import SeatsClassifier from "@/components/screener/physicalEvent/SeatsClassifier";
import SeatsCart from "@/components/screener/physicalEvent/SeatsCart";
import SeatsChart from "@/components/screener/physicalEvent/SeatsChart";
import SeatSVG from "@/components/SeatSVG";
import { seatMethods } from "@/mixins/seats";
import { currencySymbol } from "@/mixins/monetization";
import { mapState, mapGetters } from "vuex";
import i18n from "@/i18n";
import SeatMatrix from "@/components/seats/SeatMatrix";
import SeatTypeLabels from "@/components/seats/SeatTypeLabels";
export default {
  name: "VenueSeats",
  props: {
    venue: {
      type: Object,
      default: null,
    },
  },
  components: {
    SeatSVG,
    SeatsClassifier,
    SeatsCart,
    SeatsChart,
    SeatMatrix,
    SeatTypeLabels,
  },
  data() {
    return {
      loader: false,
      seats: {},
      selectedSeats: [],
      not_for_sale: [],
      reservedSeats: {},
      seatsStatus: {},
      bookings: {},
      chartConfig: {
        rows: null,
        cols: null,
      },
      selectedCategory: null,
      cartHeaders: [
        {
          text: "Category",
          align: "left",
          sortable: false,
          value: "category",
        },
        {
          text: "Seat No",
          align: "left",
          sortable: false,
          value: "label",
        },
        {
          text: "Price",
          align: "left",
          sortable: false,
          value: "price",
        },
      ],
      seatActions: [
        {
          title: "Reset",
          color: "grey",
          icon: "mdi-refresh",
          handler: this._resetSelectedSeats,
        },
        {
          title: "Reserve",
          color: "customPrimary",
          icon: "mdi-checkbox-marked-circle-",
          handler: this.reserveSeats,
        },
      ],
      selectedCategory: null,
      selectedSeatsPrice: null,
      physical_venue_seats_pricing: this.initilisePhysicalSeatsPricing(),
    };
  },
  watch: {
    venue: {
      deep: true,
      handler: function () {
        if (!this.venue) {
          return;
        }
        this.setRowCols();
        this.setSeats();
        this.setReservedSeats();
        // this.getSeatsStatus();
      },
    },
    selectedSeats:{
      deep: true,
      handler: function () {
        this.$emit('onSeatSelected',this.selectedSeats)
      },
    }
  },
  mixins: [seatMethods, currencySymbol],
  computed: {
    ...mapGetters("company", {
      selected_company: "getSelectedCompany",
    }),
    availableSeats() {},
  },

  methods: {
    setRowCols() {
      this.chartConfig.rows = this.venue.rows;
      this.chartConfig.cols = this.venue.columns;
    },
    setSeats() {
      this.seats = this.venue.seats;
    },
    setReservedSeats() {
      this.reservedSeats = this.venue.not_for_sale;
    },
    reset() {
      this._resetSelectedSeats();
      this.dialog = false;
    },
    _resetSelectedSeats() {
      this.selectedSeats = [];
    },
    _removeSeatFromSelected(seatId) {
      this.selectedSeats = this.selectedSeats.filter(
        (seat) => seat.id !== seatId
      );
      return this.selectedSeats;
    },
    _addSeatToSelected(seatId) {
      this.selectedSeats.push(this.getSeat(seatId));
    },
    onSeatSelected(seatId) {
      if (this._isSeatSelected(seatId)) {
        this._removeSeatFromSelected(seatId);
        return;
      }
      // User can selected upto defined max seats only
      // if (
      //   this.selectedSeats.length == this.DEFINES.MAXIMUM_SEAT_SELECTION_AT_ONCE
      // ) {
      //   return;
      // }
      this._addSeatToSelected(seatId);
    },
    async getSeatsStatus() {
      try {
        this.loader = true;
        let response = await this.$store.dispatch("screener/getSeatsStatus", {
          venue_id: this.venue.id,
        });
        this.seatsStatus = response.seats_status;
        this.loader = false;
      } catch (error) {
        this.loader = false;
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    async reserveSeats() {
      if (!this.selectedSeats.length) {
        return;
      }
      const payload = {
        venue_id: this.venue.id,
        seats: this.selectedSeats.map((seat) => seat.id),
      };
      try {
        let response = await this.$store.dispatch(
          "bookings/markSeatsLocked",
          payload
        );
        /* FIXME::Close the seat selection dialog & redirect to checkout step */
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    onCancel() {
      this.$emit("onCancel");
    },
    onConfirm() {
      this.$emit("onConfirm");
    },
    async updateSeats(category) {
      let selected_seats_ids = this.selectedSeats.map((seat) => seat.id);
      await this.$store
        .dispatch("venue/updateSeats", {
          venue_id: this.venue.id,
          selected_seats: selected_seats_ids,
          category: category,
          price: this.selectedSeatsPrice,
        })
        .then((response) => {
          this.selectedSeats = [];
          this.$emit("onUpdateVenue", response.venue);
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        });
    },

    _countSeatsWithStatus(status) {
      let seats_array = Object.keys(this.seatsStatus).filter((key) => {
        if (this.seatsStatus[key]["status"] == status) {
          return this.seatsStatus[key];
        }
      });
      return seats_array.length;
    },

    selectRowSeats(event) {
      for(let col=1; col <= this.venue.columns; col++){
        let seat = this.getSeat(`${event.row}-${col}`);
        if(!this._isSeatSelected(seat.id)){
          this.selectedSeats.push(seat)
        }
      }
    },
    selectColumnSeats(event) {
      for(let row=1; row <= this.venue.rows; row++){
        let seat = this.getSeat(`${row}-${event.col}`);
        if(!this._isSeatSelected(seat.id)){
          this.selectedSeats.push(seat)
        }
      }
    },
    selectAllSeats() {
      return Object.values(this.venue.seats).forEach((value) => {
        if(!this._isSeatSelected(value.id)){
          this.selectedSeats.push(value)
        }
      });
    },

    initilisePhysicalSeatsPricing() {
      if (this.venue_seats_pricing) {
        return this.venue_seats_pricing;
      }
      let pricing = new Object();
      pricing[this.DEFINES.SEAT_CATEGORIES_VALUE["REGULAR"]] = 0;
      pricing[this.DEFINES.SEAT_CATEGORIES_VALUE["CHEAPER"]] = 0;
      pricing[this.DEFINES.SEAT_CATEGORIES_VALUE["PREMIUM"]] = 0;
      pricing[this.DEFINES.SEAT_CATEGORIES_VALUE["DISABLED"]] = 0;
      return pricing;
    },

    async markUnavailableSeats() {
      let not_for_sale = this.selectedSeats.map((seat) => seat.id);
      await this.$store
        .dispatch("venue/markUnavailableSeats", {
          venue_id: this.venue.id,
          not_for_sale: not_for_sale,
        })
        .then((response) => {
          this.$store.dispatch("app/showMessage", {
            message: i18n.t("screener.booking.seats.updated.success.message"),
            color: "success",
          });
          this.selectedSeats = [];
          this.$emit("onUpdateVenue", response.venue);
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        });
    },


    async markSeatsInaccessible() {
      await this.$store.dispatch("venue/markSeatsInaccessible", {
          selected_seats: this.selectedSeats.map((seat) => seat.id),
          venue_id: this.venue.id,
        })
        .then((response) => {
          this.selectedSeats = [];
          this.$emit("onUpdateVenue", response.venue);
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        });
    },
    async markAvailableSeats() {
      let available_for_sale = this.selectedSeats.map((seat) => seat.id);
      await this.$store
        .dispatch("venue/markAvailableSeats", {
          venue_id: this.venue.id,
          available_for_sale: available_for_sale,
        })
        .then((response) => {
          this.$store.dispatch("app/showMessage", {
            message: i18n.t("screener.booking.seats.updated.success.message"),
            color: "success",
          });
          this.selectedSeats = [];
          this.$emit("onUpdateVenue", response.venue);
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        });
    },
    async markSeatsAccessible() {
      await this.$store.dispatch("venue/markSeatsAccessible", {
          selected_seats: this.selectedSeats.map((seat) => seat.id),
          venue_id: this.venue.id,
        })
        .then((response) => {
          this.selectedSeats = [];
          this.$emit("onUpdateVenue", response.venue);
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        });
    },

  },
};
</script>
<style scoped>

</style>
